module.exports = __webpack_public_path__ + "img/adaptations1.0fc27e6f.png";